import {
	LOAD_CHAT,
	NEW_CHAT,
	UPDATE_CHAT_BY_ID,
	UPDATE_CHAT,
	LOAD_CHAT_OFFSET
} from '../actions/chat.action';
import { IActionBase } from '../models/root.interface';
import { ChatInterface } from '../models/conversation.interface';
import groupBy from 'lodash/groupBy';
import { findIndex } from 'lodash';
import uniqBy from 'lodash/uniqBy';

const initialState: ChatInterface = {
	byId: {
		'': [
			{
				conversation_id: '',
				company_id: '',
				user_id: '',
				from_identifier: '',
				to_identifier: '',
				direction: '',
				service: '',
				status: 0,
				agent_name: '',
				created_at_ts: 0,
				modified_at_ts: 0,
				reason: '',
				content: {
					media_url: '',
					mime_type: '',
					button_values: [],
					location: '',
					body: '',
				}
			},
		],
	},
	byIdOffSet: {},
	allIds: [],
};

function chatReducer(
	state: ChatInterface = initialState,
	action: IActionBase
): ChatInterface {
	switch (action.type) {
		case LOAD_CHAT:
			if (action.payload) {
				let normalizedChat: any = groupBy(action.payload, 'to_identifier');
				if (state.byId[Object.keys(normalizedChat)[0]]) {
					normalizedChat[Object.keys(normalizedChat)[0]] = uniqBy([...state.byId[Object.keys(normalizedChat)[0]], ...action.payload], 'conversation_id');
				}
				return {
					...state,
					byId: { ...state.byId, ...normalizedChat },
					allIds: [...state.allIds, ...Object.keys(normalizedChat)],
				};
			} else {
				return state;
			}
		case NEW_CHAT:
			// brand new entry in the state
			return {
				...state,
				byId: {
					...state.byId,
					[action.newChatToAdd[0].to_identifier]: action.newChatToAdd,
				},
				allIds: [...state.allIds, action.newChatToAdd[0].to_identifier],
			};
		case UPDATE_CHAT_BY_ID: {
			const chatIndex = findIndex(
				state.byId[action.chatToUpdateById.to_identifier],
				(chat) => {
					return (
						chat.conversation_id ===
						action.chatToUpdateById.conversation_id
					);
				}
			);
			return {
				...state,
				byId: {
					...state.byId,
					[action.chatToUpdateById.to_identifier]: [
						...state.byId[
							action.chatToUpdateById.to_identifier
						].slice(0, chatIndex),
						action.chatToUpdateById,
						...state.byId[
							action.chatToUpdateById.to_identifier
						].slice(chatIndex + 1),
					],
				},
			};
		}
		// update existing chat in the state
		case UPDATE_CHAT:
			return {
				...state,
				byId: {
					...state.byId,
					[action.chatToUpdate.to_identifier]: [
						action.chatToUpdate,
						...state.byId[action.chatToUpdate.to_identifier],
					],
				},
			};

		case LOAD_CHAT_OFFSET:
			return {
				...state,
				byIdOffSet: {
					...state.byIdOffSet,
					[action.payload.identifier]: {
						limit: action.payload.limit,
						page: action.payload.page,
						total: action.payload.total
					}
				}
			}
		default:
			return state;
	}
}

export default chatReducer;
